/**
 * @desc 结算分页查询
 */
const URL = "/rantion-plat-data-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.platDataFlow.reportPage.settlementPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/reportPage/settlementPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
